__turbopack_context__.v({
  "alert": "hUV4ba_alert",
  "danger": "hUV4ba_danger",
  "icon": "hUV4ba_icon",
  "info": "hUV4ba_info",
  "inner": "hUV4ba_inner",
  "p": "hUV4ba_p",
  "success": "hUV4ba_success",
  "warning": "hUV4ba_warning",
});
